<app-spinner *ngIf="isLoading$ | async"></app-spinner>

@if (isCeara) {
  <app-header-ceara [isHome]="isHome()"></app-header-ceara>
  <app-alert class="d-grid"></app-alert>
  <main class="content" [ngClass]="{ 'content-padding': !isHome(), 'home-ceara': isHome() }" [ngStyle]="styles" *ngIf="styles">
    <div class="container main-container">
      <app-cookie-consent (setCookies)="setShowAvatar()"></app-cookie-consent>
      <router-outlet></router-outlet>
    </div>
  </main>
} @else {
  <app-header class="z-index11"></app-header>
  <app-alert class="d-grid"></app-alert>
  <main class="content" [ngStyle]="styles" *ngIf="styles">
    <div class="container main-container">
      <app-cookie-consent (setCookies)="setShowAvatar()"></app-cookie-consent>
      <router-outlet></router-outlet>
    </div>
  </main>
}

<app-footer></app-footer>
@if (avatarFoto && showAvatar) {
  <div class="floating-help-button" (click)="redirectToWhatsApp()" [ngStyle]="styles">
    <img [src]="avatarFoto" alt="Avatar" class="avatar" />
    <span>Precisa <br />de ajuda?</span>
  </div>
}
